<template>
  <div :class="['import-pane']">
    <div :class="['p-2']">
      <table-layout full-width y-align="middle">
        <row>
          <cell :class="['icon-cell']">
            <icon name="camera-burst" />
          </cell>
          <cell v-html="title()" :class="['import-pane-title']" />
          <cell :class="['icon-cell']" x-align="right">
            <icon
              name="close"
              @click.native="$root.importPane = false"
              :disabled="$root.selectedLayer === null"
              :class="['cursor-pointer']" />
          </cell>
        </row>
      </table-layout>
      <div>
        <p v-html="lang.importPaneInfo" :class="['mt-4']" />
        <import-file />
      </div>
    </div>
  </div>
</template>
<script>
import ImportFile from '../components/import-file'
import lang from '../helpers/lang'
import methods from '../helpers/methods'

export default {
  name: 'ImportPane',
  components: {
    ImportFile
  },
  mixins: [
    methods
  ],
  data () {
    return {
      lang
    }
  }
}
</script>
<style>
.import-pane
{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, .1);
  backdrop-filter: blur(var(--em-1));
}

.import-pane p
{
  font-size: var(--em-4);
  line-height: var(--em-6);
}

.import-pane a
{
  color: var(--white);
}

.import-pane > div
{
  width: 360px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, .75);
  box-shadow: 0 0 var(--em-2) var(--darkest);
  font-size: var(--em-3);
}

.import-pane .import-pane-title
{
  font-size: var(--em-5);
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/components/import-pane.vue